/* Cal.eu element-click embed generated for the Livia Azzurro showroom calendar. */
(function (C, A, L) {
  var p = function (a, ar) { a.q.push(ar); };
  var d = C.document;

  C.Cal = C.Cal || function () {
    var cal = C.Cal;
    var ar = arguments;

    if (!cal.loaded) {
      cal.ns = {};
      cal.q = cal.q || [];
      d.head.appendChild(d.createElement("script")).src = A;
      cal.loaded = true;
    }

    if (ar[0] === L) {
      var api = function () { p(api, arguments); };
      var namespace = ar[1];
      api.q = api.q || [];

      if (typeof namespace === "string") {
        cal.ns[namespace] = cal.ns[namespace] || api;
        p(cal.ns[namespace], ar);
        p(cal, ["initNamespace", namespace]);
      } else {
        p(cal, ar);
      }
      return;
    }

    p(cal, ar);
  };
})(window, "https://app.cal.eu/embed/embed.js", "init");

Cal("init", "spotkanie-w-showroomie", { origin: "https://app.cal.eu" });
Cal.config = Cal.config || {};
Cal.config.forwardQueryParams = true;

Cal.ns["spotkanie-w-showroomie"]("ui", {
  cssVarsPerTheme: {
    light: { "cal-brand": "#23212c" },
    dark: { "cal-brand": "#fbfaf6" }
  },
  hideEventTypeDetails: false,
  layout: "month_view"
});
